import { useCallback } from 'react';
import useGetFieldLabel from 'hooks/useGetFieldLabel';

const useFieldLabel = () => {
  const { getFieldLabel } = useGetFieldLabel();

  const getLabel = useCallback(
    ({ field, dataType }: { field: string; dataType: string }): string => {
      return getFieldLabel({ field, dataType });
    },
    [getFieldLabel],
  );

  return getLabel;
};

export default useFieldLabel;
